import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Container,
    Typography,
  } from "@mui/material";

  import { Link, useNavigate } from "react-router-dom";
  import { useSelector } from "../store";

  import React, { useEffect } from "react";
  import plus from "../assets/images/website/plus.png";
  
  function AboutUs() {
    const [expanded, setExpanded] = React.useState(false);
    const navigate = useNavigate()
    const { username } = useSelector((state) => state.auth);

    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
    const handleChange = (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
    };
    return (
      <React.Fragment>
        <Container maxWidth="xl">
            <Box
              sx={{
                maxWidth: "1400px",
                padding: {xs: '65px 0px 107px' , lg: "140px 0px"},
                margin: "auto",
                textAlign: "center",
              }}
            >
            
              

              <Typography
                sx={{
                  color: "#000",
                  fontWeight: 700,
                  fontFamily: '"Inter", sans-serif',
                  fontSize: { xs: 36, lg: 54 },
                  lineHeight: { xs: '44px', lg: "65px" },
                  maxWidth: '800px',
                  margin: { xs: 'auto', lg: 0 },
                  textAlign: { xs: 'center', lg: 'start' }
                }}
              >
               About Us
              </Typography>
              <Typography
                sx={{
                  color: "#000",
                  fontWeight: 400,
                  fontFamily: '"Inter", sans-serif',
                  fontSize: { xs: 18, lg: 22 },
                  padding: "24px 0px 60px",
                  textAlign: { xs: 'center', lg: 'start' }
                }}
              >
              
              Povego is a marketplace where you can trade tokens.
<br/><br/>
              It is Türkiye's real asset-backed blockchain-based investment platform.
<br/><br/>
              It was founded in 2023 by an expert team from the technology and finance worlds.
<br/><br/>
              The strong experience of FIA (Financial Communication Agency), Türkiye's first Financial Communication Agency, which has been providing financial communication services to Türkiye's leading finance brands for 6 years, became the cornerstone of Povego. Since stepping into the financial world, we have reinforced the financial communication consultancy experience we offer to the leading actors of the capital markets, which has inspired the communication ecosystem, with Povego, which we started to popularize blockchain-based investments in Türkiye. Our first tokenization project, the electricity token Charget, was successfully implemented in 2024 regarding the energy sector. As Povego, we aim to maintain our pioneering role in the investment world of the future steadily.<br/><br/>

              We are starting a new era in the investment world. With our innovative platform, we offer a safer, more transparent, and accessible investment environment to our investors through tokenized assets. We aim to offer new opportunities to both individual and institutional investors by joining our token ecosystem.

<br/><br/>

              Emerging as an alternative channel to the investment world, Povego is a secure marketplace where you can trade by tokenizing investment-worthy assets whose counterpart based on real trade is product, service, and commercial.

<br/><br/>

              <strong>Povego's Mission and Vision</strong><br/><br/>

              <strong>Our Mission</strong><br/><br/>
              
              We act with the mission of creating a secure and innovative investment ecosystem for investors by combining physical assets with blockchain technology.<br/><br/>
              
              <strong>Our Vision</strong><br/><br/>
              
              We aim to carry our pioneering role in the investment world of the future to the global arena as Türkiye's first real asset-backed blockchain-based investment platform.<br/><br/>

              <strong>FIA Communication Agency and Consultancy Joint Stock Company</strong><br/><br/>

              Specializing in the financial services sector, FIA, Türkiye's first financial communication agency, has been continuing its activities since 2019. Providing financial communication consultancy services to our country's most valuable financial institutions directly or through its subsidiaries, FIA Communication Agency gives life to many new projects using the experience it possesses. Carrying out its activities in a habitat where hundreds of employees take place together with the Agency and group companies operating in various fields, FIA actively serves Ziraat Bank, Ziraat Participation, Ziraat Investment, Ziraat Technology, Ziraat Portfolio and Ziraat REIT from Ziraat Finance Group, and Borsa Istanbul, Takas Istanbul (Clearing Istanbul), and Central Registry Istanbul companies from Borsa Istanbul Group. It currently has 28 active employees.

<br/><br/>

              In 2023, it established the Povego company, of which it owns all shares. As stated in its Articles of Association, Povego, established to perform all kinds of digital asset buying and selling transactions and to carry out platform activities for this purpose, positions itself at the intersection of innovation and the finance sector. This platform, where tokens possessing physical assets and also having solid financial backing will be traded, aims to offer a reliable environment for investment and trade; it encourages all segments from global investors to institutions, from individual investors to savers, to participate in the dynamic world of digital assets.<br/><br/>


</Typography>
            </Box>
          </Container>
      </React.Fragment>
    );
  }
  
  export default AboutUs;
  
